import React, { useState } from 'react';
import './styles.scss';
import Button from '../../components/Button';
import { Row, Col, Input, message } from 'antd';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/store';

const AscendeumTag: React.FC = () => {
  const isDarkMode = useSelector((state: AppState) => state.isDarkMode);
  
  // Track the placement key
  const [placement, setPlacement] = useState<string>('');
  // Store the generated snippet
  const [snippet, setSnippet] = useState<string>('');

  // Build and display snippet on button click
  const handleCreate = () => {
    const code = `<div data-aaad='true' data-aa-adunit='${placement}'>\n  <script>\n    try{window.asc.processAdsOnPage();}catch(err){}\n  </script>\n</div>`;
    setSnippet(code);
  };

  // Copy snippet to clipboard
  const handleCopy = () => {
    if (!snippet) return;
    navigator.clipboard.writeText(snippet).then(() => {
      message.success('Code copied to clipboard!');
    }).catch(() => {
      message.error('Failed to copy.');
    });
  };

  return (
    <>
      <Row className="ascendeum full-width" justify="space-between">
        <Col className="title">
          <div style={{ color: isDarkMode ? '#FDB813' : '#4097FF' }}>
            Create Ascendeum Tag
          </div>
        </Col>
      </Row>

      <Row gutter={16} className="ascendeum full-width" justify="start">
        <Col>
          <Input
            placeholder="Enter placement key"
            value={placement}
            onChange={e => setPlacement(e.target.value)}
            style={{ width: 300 }}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            title="Create Ascendeum Tag"
            onClick={handleCreate}
            disabled={!placement.trim()}
          />
        </Col>
      </Row>

      {/* Render the generated snippet and copy button */}
      {snippet && (
        <Row className="ascendeum full-width" justify="start" style={{ marginTop: 20 }}>
          <Col span={24}>
            <pre style={{ background: '#f5f5f5', padding: 12, borderRadius: 4, position: 'relative' }}>
              <code className="language-html">{snippet}</code>
            </pre>
          </Col>
          <Col>
            <Button
              type="default"
              title="Copy Code"
              onClick={handleCopy}
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default AscendeumTag;
